import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, MailCheck, KeyRound } from "lucide-react";
import { api, errMsg, COMPANY } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function AuthShell({ title, subtitle, children, testId }) {
  return (
    <div className="min-h-screen login-bg flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute top-10 right-10 h-64 w-64 rounded-full bg-sky-200/50 blur-3xl aurora" />
      <div className="absolute bottom-10 left-10 h-72 w-72 rounded-full bg-cyan-100/70 blur-3xl aurora aurora-2" />
      <div className="relative w-full max-w-md rounded-3xl p-[1.5px] bg-gradient-to-br from-sky-300 via-white to-cyan-200 shadow-2xl shadow-sky-200/60 rise" data-testid={testId}>
        <div className="glass rounded-[22px] p-8 sm:p-10">
          <div className="flex flex-col items-center text-center mb-6">
            <img src={COMPANY.logo} alt="Logo" className="h-20 w-20 object-contain drop-shadow-lg logo-float" />
            <div className="mt-2 text-sm font-extrabold tracking-[0.12em] uppercase text-slate-800">{COMPANY.name}</div>
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-slate-900 text-center">{title}</h2>
          <p className="text-sm text-slate-500 mt-1 text-center">{subtitle}</p>
          <div className="wave-line w-16 mt-4 mb-7 mx-auto" />
          {children}
        </div>
      </div>
    </div>
  );
}

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Lupa Password?" subtitle="Masukkan email akun Anda. Kami kirimkan tautan untuk membuat password baru dan memberi tahu admin." testId="forgot-page">
      {sent ? (
        <div className="text-center" data-testid="forgot-success">
          <div className="mx-auto h-14 w-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center"><MailCheck className="h-7 w-7" /></div>
          <p className="mt-4 text-sm text-slate-700">Jika email <b>{email}</b> terdaftar, tautan reset sudah dikirim (berlaku 1 jam). Periksa kotak masuk / spam Anda.</p>
          <p className="mt-2 text-xs text-slate-500 inline-flex items-center gap-1"><KeyRound className="h-3.5 w-3.5" /> Admin juga menerima notifikasi dan dapat mengatur password Anda secara manual.</p>
          <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-sky-700 font-semibold hover:underline" data-testid="link-back-login"><ArrowLeft className="h-4 w-4" /> Kembali ke login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-slate-700">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-sky-500" />
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="nama@cahayafishbali.com" className="h-12 pl-10 rounded-xl bg-white/90 border-sky-200" data-testid="input-forgot-email" />
            </div>
          </div>
          {error && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-xl px-3 py-2" data-testid="forgot-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-gradient-to-r from-sky-600 to-cyan-500 hover:from-sky-700 hover:to-cyan-600 font-semibold" data-testid="btn-forgot-submit">{loading ? "Mengirim..." : "Kirim Tautan Reset"}</Button>
          <Link to="/login" className="flex items-center justify-center gap-1 text-sm text-sky-700 font-semibold hover:underline" data-testid="link-back-login"><ArrowLeft className="h-4 w-4" /> Kembali ke login</Link>
        </form>
      )}
    </AuthShell>
  );
}
